<template>
<div class="chapter">
<div class="inner_page">
<h1>Gobseck &amp;</h1>
<h1 class="sigil_not_in_toc">At the Sign of the</h1>
<h1 class="sigil_not_in_toc">Cat and Racket</h1>
<h2 class="sigil_not_in_toc">Honoré de Balzac</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6cda7519